import React from 'react'

const Tooltip = ({children, title}) => {
    return <div className="tooltipCustom">
	{children}
	<div className="message"><div>{title}</div></div>
    </div>
}
export default Tooltip
